module.exports = __webpack_public_path__ + "static/media/upload-icon-bg-alt.c62b8898.png";